{
  "commentConditions": "All comments will be published {linkToDefinition} in the City of Helsinki online service {linkToLicense}. If you are not logged in, you may leave an anonymous comment. The comments may be moderated if they contain insulting or offensive language.",
  "fullscreenHeaderLogoAlt": "City of Helsinki logo",
  "footerLogoAlt": "City of Helsinki logo",
  "headerLogoAlt": "Go to the home page",
  "copyrightHolder": "City of Helsinki",
  "copyrightText": "All rights reserved.",
  "footerCityLink": "www.hel.fi"
}
